import { Reveal } from "@/components/landing/Reveal";
import { coaches } from "@/lib/landingData";
import { Bot } from "lucide-react";

export const DreamTeam = () => {
  return (
    <section data-testid="coaches" id="coaches" className="relative py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gradient">
            Your Personal AI Dream Team
          </p>
          <h2 className="mt-5 font-mega text-4xl leading-[0.95] text-white sm:text-5xl lg:text-6xl">
            Not One Generic AI.
            <br />
            A Team of <span className="text-gradient">Specialists</span>
          </h2>
          <p className="mt-6 text-lg text-muted-foreground">
            You get a team of specialized AI coaches working together &mdash; each an
            expert in their domain.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {coaches.map((c, i) => (
            <Reveal
              key={c.title}
              delay={i * 0.06}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0C0C0E] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-white/25"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full glow-violet opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-brand text-black">
                <Bot className="h-6 w-6" />
              </div>
              <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white">
                {c.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                {c.copy}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DreamTeam;
